/**
 * Config declarativo do fluxo de solicitação/aprovação/recusa de reabertura.
 */
export const saleReopenConfig = {
  /** Role exigida no dropdown de destinatários (query `role`). */
  recipientRole: "Reabrir Vendas",
  paths: {
    recipientSelectionOptions: "/sale/recipient-selection-options",
    requestReopen: (idsale) => `/sale/${idsale}/request-reopen`,
    approveReopen: (idsale) => `/sale/${idsale}/approve-reopen`,
    rejectReopen: (idsale) => `/sale/${idsale}/reject-reopen`,
  },
  reasonMaxLength: 5000,
};
